import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const MorphModal = ({ selectedItem, show, onClose }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [singleImageMode] = useState(true);
    const [gridMode, setGridMode] = useState(false);
    const isMobile = window.innerWidth <= 768;

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? selectedItem.images.length - 1 : prevIndex - 1
        );
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === selectedItem.images.length - 1 ? 0 : prevIndex + 1
        );
    };

    if (!selectedItem) {
        return null;
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="lg"
            aria-labelledby="custom-modal-styling"
            className="custom-modal"
            fullscreen="lg-down"
        >
            <Modal.Header closeButton>
                <Modal.Title>Owner - {selectedItem.actorUsername}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {selectedItem.images?.length > 0 && (
                    singleImageMode ? (
                        <div className="text-center">
                            <img
                                src={selectedItem.images[currentImageIndex]?.presignedUrl}
                                alt="morph"
                                style={{
                                minWidth: isMobile ? '320px' : 'auto',
                                maxWidth: "100%",
                                height: isMobile ? '60vh' : '75vh',
                                objectFit: 'contain',
                                margin: '5px'
                                }}
                            />
                            <div className="mt-2">
                                <Button variant="secondary" onClick={handlePrevImage}>Prev</Button>{' '}
                                <Button variant="secondary" onClick={handleNextImage}>Next</Button>
                            </div>
                        </div>
                ) : (
                    gridMode ? (
                        <div
                            className="morph-image-grid"
                            style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile
                                ? 'repeat(auto-fit, minmax(300px, 1fr))'
                                : 'repeat(auto-fill, minmax(350px, 1fr))',
                            gap: '10px',
                            justifyItems: 'center'
                            }}
                        >
                            {selectedItem.images.map((img, idx) => (
                            <img
                                key={idx}
                                src={img.presignedUrl}
                                alt="morph"
                                style={{
                                width: '100%',
                                height: '100%',
                                maxHeight: '250px',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                }}
                            />
                            ))}
                        </div>
                    ) : (
                    <div className="d-flex flex-wrap justify-content-center scroll-morph-images">
                        {selectedItem.images.map((img, idx) => (
                        <img
                            key={idx}
                            src={img.presignedUrl}
                            alt="morph"
                            style={{
                            width: 'auto',
                            minWidth: isMobile ? '320px' : 'auto',
                            height: 'auto',
                            margin: '5px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                        />
                        ))}
                    </div>
                    )
                ))}

                <div className="d-flex justify-content-between mt-3">
                    {/* <Button
                        variant="outline-secondary"
                        onClick={() => setSingleImageMode(!singleImageMode)}
                    >
                        <i className="fa-solid fa-rotate"></i>
                    </Button> */}

                    {!singleImageMode && (
                        <Button
                        variant="outline-secondary"
                        onClick={() => setGridMode(!gridMode)}
                        >
                        <i className="fa-solid fa-toggle-on"></i>
                        </Button>
                    )}
                </div>

                <div className="mt-4 d-flex flex-column flex-sm-row justify-content-between gap-3">
                    <div className="card" style={{ flex: 5, backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>Description:</h5>
                            <p className="card-text mt-4">{selectedItem.description}</p>
                        </div>
                    </div>

                    <div className="card text-end" style={{ flex: 2, backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            <h5 className="card-title" style={{ color: "white" }}>Card Code:</h5>
                            <p className="card-text mt-4">{selectedItem.card_code}</p>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MorphModal;
